/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Validation issue for a single IdP claim mapping row
 * @export
 * @interface IdpClaimMappingValidationIssue
 */
export interface IdpClaimMappingValidationIssue {
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    mappingId?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    claimType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    claimValue?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    severity?: IdpClaimMappingValidationIssueSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationIssue
     */
    message?: string;
}


/**
 * @export
 */
export const IdpClaimMappingValidationIssueSeverityEnum = {
    Error: 'ERROR',
    Warning: 'WARNING',
    Info: 'INFO'
} as const;
export type IdpClaimMappingValidationIssueSeverityEnum = typeof IdpClaimMappingValidationIssueSeverityEnum[keyof typeof IdpClaimMappingValidationIssueSeverityEnum];


/**
 * Check if a given object implements the IdpClaimMappingValidationIssue interface.
 */
export function instanceOfIdpClaimMappingValidationIssue(value: object): value is IdpClaimMappingValidationIssue {
    return true;
}

export function IdpClaimMappingValidationIssueFromJSON(json: any): IdpClaimMappingValidationIssue {
    return IdpClaimMappingValidationIssueFromJSONTyped(json, false);
}

export function IdpClaimMappingValidationIssueFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdpClaimMappingValidationIssue {
    if (json == null) {
        return json;
    }
    return {
        
        'mappingId': json['mapping_id'] == null ? undefined : json['mapping_id'],
        'claimType': json['claim_type'] == null ? undefined : json['claim_type'],
        'claimValue': json['claim_value'] == null ? undefined : json['claim_value'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function IdpClaimMappingValidationIssueToJSON(json: any): IdpClaimMappingValidationIssue {
    return IdpClaimMappingValidationIssueToJSONTyped(json, false);
}

export function IdpClaimMappingValidationIssueToJSONTyped(value?: IdpClaimMappingValidationIssue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mapping_id': value['mappingId'],
        'claim_type': value['claimType'],
        'claim_value': value['claimValue'],
        'severity': value['severity'],
        'code': value['code'],
        'message': value['message'],
    };
}

